define([
    'lodash',
    'localSiteSerializer/utils/deepSort'
], function (_, deepSort) {
    'use strict';

    const assignIfTruthy = (val, prop) => val ? {[prop]: val} : {};

    return {
        serialize: ({pagesData, rendererModel, pagesPlatformApplications}) => {
            const pagePlatformAppsByPageId = _.reduce(pagesPlatformApplications, (pageAcc, value, key) =>
                _.reduce(value, (acc, _p, pageId) => {
                    acc[pageId] = acc[pageId] || [];
                    acc[pageId].push(key);
                    return acc;
                }, pageAcc), {});

            const pageToBehaviorItTriggers = _(pagesData)
                .mapValues(({data, structure}, pageId) => {
                    const behaviorQuery = structure.behaviorQuery;
                    if (!behaviorQuery) {
                        return null;
                    }
                    const behavior = data.behaviors_data[behaviorQuery];
                    const items = JSON.parse(behavior.items);
                    const popupTrigger = _.find(items, {action: {sourceId: pageId}, behavior: {name: 'openPopup'}});

                    return popupTrigger ? {
                        behavior,
                        sourceId: pageId,
                        targetId: popupTrigger.behavior.targetId
                    } : null;
                })
                .omitBy(_.isNull)
                .value();

            const theTriggeredPopupBehaviors = _.mapKeys(pageToBehaviorItTriggers, 'targetId');

            return {
                pages: _(pagesData)
                    .keys()
                    .filter(pageId => pageId !== 'masterPage')
                    .reduce((accumulator, pageId) => {
                        const {pageUriSEO, title, isPopup, id} = pagesData.masterPage.data.document_data[pageId];
                        const triggerToAdd = theTriggeredPopupBehaviors[pageId];
                        const triggerToRemove = pageToBehaviorItTriggers[pageId];

                        accumulator[pageId] = {
                            pageUriSeo: pageUriSEO,
                            title,
                            isPopup,
                            pageId: id,
                            content: _.assign({},
                                pagesData[pageId],
                                assignIfTruthy(_.get(pagePlatformAppsByPageId, pageId), 'pagesPlatformApplications'),
                                assignIfTruthy(rendererModel.passwordProtectedPages && rendererModel.passwordProtectedPages.find(page => page === pageId), 'passwordProtectedPages')
                            )
                        };

                        if (triggerToAdd) {
                            accumulator[pageId].content.lightbox_trigger = triggerToAdd;
                        }

                        if (triggerToRemove) {
                            _.unset(pagesData[pageId], ['data', 'behaviors_data', triggerToRemove.behavior.id]);
                            _.unset(pagesData[pageId], ['structure', 'behaviorQuery']);
                        }

                        _.unset(pagesData.masterPage.data.document_data[pageId], 'pageUriSEO');
                        _.unset(pagesData.masterPage.data.document_data[pageId], 'title');
                        return accumulator;
                    }, {})
            };
        },
        deserialize: payload => ({
            pagesData: _(payload.pages)
                .keys()
                .filter(pageId => pageId !== 'masterPage')
                .reduce((accumPagesData, pageId) => {
                    const lightboxTrigger = payload.pages[pageId].content.lightbox_trigger;
                    const content = _.omit(deepSort(payload.pages[pageId].content), ['lightbox_trigger', 'pagesPlatformApplications', 'passwordProtectedPages']);
                    const behaviorId = _.get(lightboxTrigger, ['behavior', 'id'], null);
                    const deserializedTriggerInOtherPage = behaviorId ? {
                        [lightboxTrigger.sourceId]: {data: {behaviors_data: {[behaviorId]: lightboxTrigger.behavior}}, structure: {behaviorQuery: behaviorId}}
                    } : {};
                    return _.merge(accumPagesData, deserializedTriggerInOtherPage, {
                        [pageId]: _.assign(content, {title: payload.pages[pageId].title, pageUriSEO: payload.pages[pageId].pageUriSeo}),
                        masterPage: {
                            data: {
                                document_data: {
                                    [pageId]: {
                                        isPopup: payload.pages[pageId].isPopup,
                                        title: payload.pages[pageId].title,
                                        pageUriSEO: payload.pages[pageId].pageUriSeo,
                                        id: payload.pages[pageId].pageId
                                    }
                                }
                            }
                        }
                    });
                }, {}),
            rendererModel: Object.keys(payload.pages).filter(pageId => pageId !== 'masterPage')
                .reduce((accumulator, pageId) => {
                    const page = payload.pages[pageId].content;
                    if (page.pagesPlatformApplications) {
                        accumulator.pagesPlatformApplications[pageId] = page.pagesPlatformApplications;
                    }
                    delete page.pagesPlatformApplications;
                    accumulator.passwordProtectedPages = accumulator.passwordProtectedPages.concat(page.passwordProtectedPages ? page.passwordProtectedPages : []);
                    delete page.passwordProtectedPages;
                    return accumulator;
                }, {
                    pagesPlatformApplications: {},
                    passwordProtectedPages: []
                })
        }),
        getEncryptedPaths: payload => Object.keys(payload.pages).map(pageId => `pages.${pageId}.content`)
    };
});
